import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const FinancialYearPicker = ({ value, onChange }) => {
  const [startYear, setStartYear] = useState(null);
  const [endYear, setEndYear] = useState(null);

  // 🔄 Reset internal state when formik resets `value`
  useEffect(() => {
    if (!value) {
      setStartYear(null);
      setEndYear(null);
    } else {
      const [start, end] = value.value.split("-");
      setStartYear(parseInt(start));
      setEndYear(parseInt(end));
    }
  }, [value]);

  const handleStartChange = (date) => {
    if (!date) {
      setStartYear(null);
      setEndYear(null);
      onChange(null);
      return;
    }

    const year = date.year();
    const end = year + 1;

    setStartYear(year);
    setEndYear(end);

    onChange({ value: `${year}-${end}` });
  };

  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
      <DatePicker
        picker="year"
        placeholder="Select"
        onChange={handleStartChange}
        value={startYear ? dayjs().year(startYear) : null}
        style={{ flex: 1 }}
      />
      <span>-</span>
      <DatePicker
        picker="year"
        placeholder="Select"
        value={endYear ? dayjs().year(endYear) : null}
        disabled
        style={{ flex: 1 }}
      />
    </div>
  );
};

export default FinancialYearPicker;
